import * as React from 'react';
import { TabStyles } from '@tableau/widgets';

export const Padding = 8;

export const BorderWidth = TabStyles.Sizing.BorderWidth;

export const OuterMaxWidth = 250;

export const OuterMaxHeight = 250;

export const InnerMaxWidth = OuterMaxWidth - 2 * (Padding + BorderWidth);

export const InnerMaxHeight = OuterMaxHeight - 2 * (Padding + BorderWidth);

const OuterStyle: React.CSSProperties = {
  flexGrow: 0,
  padding: Padding,
  borderWidth: BorderWidth,
  borderStyle: 'solid',
  borderColor: TabStyles.Colors.L5,
  borderRadius: TabStyles.Sizing.BorderRadius,
  boxShadow: TabStyles.Shadow.Standard,
  backgroundColor: TabStyles.Colors.White,
};

// NOTE inner div handles content overflow so that scroll bars appear within padding of outer div
const InnerStyle: React.CSSProperties = {
  maxWidth: InnerMaxWidth,
  maxHeight: InnerMaxHeight,
  overflowY: 'auto'
};

export interface ChromeTooltipBoxProps {
  readonly content: JSX.Element;
  readonly width?: number;
}

export function ChromeTooltipBox(props: ChromeTooltipBoxProps): React.ReactElement<ChromeTooltipBoxProps> {
  return (
    <div style={OuterStyle}>
      <div style={getInnerStyle(props.width)}>
        {props.content}
      </div>
    </div>
  );
}

function getInnerStyle(width?: number): React.CSSProperties {
  return { ...InnerStyle, width };
}
